import { Binding } from './type'

interface Ob {
  [key: string]: MutationObserver | ResizeObserver
}
const map: Ob = {}

export default {
  //   ob: MutationObserver.prototype,
  mounted (el: Element, binding: Binding): void {
    const fn = binding.value.bind(null, el)
    const ob = new MutationObserver(fn)
    ob.observe(el, {
      childList: true,
      characterData: true,
      subtree: true
    })
    map[el.id] = ob
    fn()
  },
  unmounted (el: Element): void {
    map[el.id].disconnect()
  }
}

export const resize = {
  mounted (el: Element, binding: Binding): void {
    const fn = () => {
      const data = el.getBoundingClientRect()
      binding.value(data)
    }
    if (window.ResizeObserver) {
      const ob = new ResizeObserver(fn)
      ob.observe(el)
      map[el.id] = ob
    }
  },
  unmounted (el: Element): void {
    map[el.id].disconnect()
  }
}
